import React from 'react';

import UpdateDonneesVehicule from 'components/UpdateDonneesVehicule/UpdateDonneesVehicule';
import { useApi } from 'hooks/ApiStoreContext';
import { useDossierContext } from 'hooks/dossiers/DossierContext';
import { useDossierComplet } from 'hooks/dossiers/useDownloadDossierComplet';
import { extractNonnullDossierIdOrThrow } from 'utils/dossierUtils';

interface UpdateDonneesVehiculeProps {
  closeModal: () => void;
}

function UpdateDonneesVehiculeFo({
  closeModal,
}: UpdateDonneesVehiculeProps): React.ReactElement {
  const [{ result, setDossier }] = useDossierContext();
  const dossierId = extractNonnullDossierIdOrThrow(result);
  const { dossier, fetchInProgress, fetchDossier, errorOccured } =
    useDossierComplet(dossierId);
  const {
    ForceOrdreControllerApi: foController,
    ReferentielControllerApi: refController,
  } = useApi();

  return (
    <UpdateDonneesVehicule
      closeModal={closeModal}
      controller={foController}
      dossierId={dossierId}
      refController={refController}
      setDossier={setDossier}
      fetchInProgress={fetchInProgress}
      fetchDossier={fetchDossier}
      errorOccured={errorOccured}
      dossierBody={dossier?.body}
    />
  );
}

export default UpdateDonneesVehiculeFo;
